// Vendor imports
const _ = require('lodash')
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Container imports
const TopCallToActionSplitLeading = require('./components/split-leading')
const TopCallToActionSplitTrailing = require('./components/split-trailing')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionSection')

function TopCallToActionSection(props) {
  return tag('div', {
    className: bem.block()
  },
    tag(TopCallToActionSplitLeading, {
      className: bem.element('leading'),
      forwardedRef: useResizeHeightListener(props.onFoldHeightChange)
    }),
    tag(TopCallToActionSplitTrailing, {
      className: bem.element('trailing')
    })
  )
}

TopCallToActionSection.propTypes = {
  onFoldHeightChange: PropTypes.func.isRequired
}

module.exports = TopCallToActionSection

// Custom React Hook

const THROTTLE_FREQUENCY = 66 // ~15 frames per second

function useResizeHeightListener(onHeightChange) {
  if (typeof window === 'undefined') {
    return // Do nothing during server-side render
  }
  const domRef = React.useRef(null)
  const heightRef = React.useRef(null)
  React.useEffect(() => {
    function onResize() {
      if (domRef.current) {
        const newHeight = domRef.current.scrollHeight
        if (newHeight !== heightRef.current) {
          onHeightChange(newHeight)
          heightRef.current = newHeight
        }
      }
    }
    onResize()
    const throttledOnResize = _.throttle(onResize, THROTTLE_FREQUENCY)
    window.addEventListener('resize', throttledOnResize)
    return () => {
      window.removeEventListener('resize', throttledOnResize)
      throttledOnResize.cancel()
    }
  })
  return domRef
}
